import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Appointment } from '../appointments/state/appointment.model';

@Component({
    selector: 'appointment-log-details',
    templateUrl: './appointment-log-details.component.html'
})

export class AppointmentLogDetailsComponent implements OnChanges {

    @Input() selectedEventLog: any;
    @Input() eventsForSelectedMessage: any;
    @Output() readonly selectAppointmentDetail: EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedAppointment: Appointment;
    @Input() loading: boolean;
    @Input() selectedTimeZone;
    currentDifference = [];
    selectedAppointmentDetail: any;

    viewingParameters: Array<string> = [
        'appointmentId',
        'reminderState',
        'remoteAppointmentId',
        'personId',
        'remotePersonId',
        'reasonName',
        'reasonId',
        'remoteReasonId',
        'location',
        'resource',
        'appointmentState',
        'appointmentTime',
        'created',
        'modified',
        'remoteAppointmentState',
        'remoteModified',
        'providerName',
        'providerId',
        'schedulerState',
        'triggerTime',
        'strategyId',
        'strategyType'
    ];

    fieldsOfDate = ['appointmentTimeMs', 'appointmentTime', 'createdMs',
                    'created', 'modifiedMs', 'modified',
                    'remoteModifiedMs', 'remoteModified'];

    getEventValByParamName(viewedParam, type): string {

        if (viewedParam === 'modified' || viewedParam === 'remoteModified') {
            return 'N/A';
        }

        let selectedAppointment;

        selectedAppointment = type === 'event' ? this.selectedEventLog : this.eventsForSelectedMessage;

        if (
            selectedAppointment.appointment !== undefined
            &&
            (selectedAppointment.appointment[viewedParam] !== undefined ||
                (selectedAppointment.appointment.after !== undefined && selectedAppointment.appointment.after[viewedParam] !== undefined))) {
            let returnValue = selectedAppointment.appointment[viewedParam];

            if (selectedAppointment.appointment.after[viewedParam] === selectedAppointment.appointment.before[viewedParam] &&
                selectedAppointment.appointment.after[viewedParam] === this.selectedAppointment[viewedParam]
            ) {
                return selectedAppointment.appointment.after[viewedParam];
            }

            if (type === 'event' && selectedAppointment.appointment.after[viewedParam]
                !== selectedAppointment.appointment.before[viewedParam]) {
                returnValue = `${selectedAppointment.appointment.before[viewedParam]} -> ${selectedAppointment.appointment.after[viewedParam]}`;
            }

            this.markAsDifferent(viewedParam);

            if (returnValue !== undefined) {
                return returnValue;
            }
        }

        const events = []; // this.getSortedEvents();
        let i = events.length;

        let eventValue = this.selectedAppointment[viewedParam];

        while (i--) {
            if (events[i].timestamp <= selectedAppointment.timestamp) {
                break;
            }

            if (events[i].appointment !== undefined && events[i].appointment[viewedParam] !== undefined) {
                continue;
            }
            eventValue = events[i].appointment[viewedParam].before;
            break;

        }

        if (eventValue !== this.selectedAppointment[viewedParam]) {
            this.markAsDifferent(viewedParam);
        }

        return eventValue;
    }

    isDateParam(viewedParam): boolean {
        return this.fieldsOfDate.indexOf(viewedParam) > -1;
    }

    markAsDifferent(viewedParam): void {
        if (this.currentDifference.findIndex(param => param === viewedParam) === -1) {
            this.currentDifference.push(viewedParam);
        }
    }

    ngOnChanges(change: SimpleChanges): void {
        if (change['selectedEventLog'] !== undefined) {
            this.currentDifference = [];
        }

        if (change['eventsForSelectedMessage'] !== undefined
            && change['eventsForSelectedMessage'].currentValue !== '') {
            this.currentDifference = [];
        }
    }

    selectedRow(event): any {
        if (this.selectedEventLog !== undefined) {
            this.selectAppointmentDetail.emit(event.data);
        }
    }

    getTriggerTimeAsTimeStamp(appointment: Appointment): number {
      if (!Boolean(appointment.triggerTime)) {
        return new Date().getTime();
      }

      const triggerTimeAsStringUTC = appointment.triggerTime.replace(" ", "T").concat("0Z");
      return new Date(triggerTimeAsStringUTC).getTime();
    }
}
